import Container from 'react-bootstrap/Container';
import styled from 'styled-components';

const CustomContainer = styled(Container)`
  padding: 0px;
`;

export default CustomContainer;
